// extracted by mini-css-extract-plugin
export default {"form":"rZfdM","wrapper":"jCMBT","description":"uDbXR","smsForm":"hRqsD","header":"nRRMY","tabText":"ktedY","tab":"r9VZo"};